export default __webpack_public_path__ + "static/media/like.63bb2ded.svg";